export const dataTickets = {
  1000: {
    results: [
      {
        id: 1,
        title_ticket: "Tickets 1",
        received_date: new Date().toISOString(),
        ticket_id: 1996,
        priority: 1,
        urgency: 1,
        category: 1,
        status: 1,
        members: [1, 2],
        client_name: "Client singapore",
        assigneeByMe: true,
        order: 1
      },
      {
        id: 2,
        title_ticket: "Tickets 2",
        received_date: new Date().toISOString(),
        ticket_id: 1992,
        priority: 5,
        urgency: 2,
        category: 2,
        status: 2,
        members: [3, 4],
        client_name: "Client India",
        order: 2
      },
      {
        id: 3,
        title_ticket: "Tickets 3",
        received_date: new Date().toISOString(),
        ticket_id: 1993,
        priority: 4,
        urgency: 3,
        category: 3,
        status: 3,
        members: [4, 5, 6],
        client_name: "Client Korea",
        assigneeByMe: true,
        order: 3
      },
      {
        id: 4,
        title_ticket: "Tickets 4",
        received_date: new Date().toISOString(),
        ticket_id: 1991,
        priority: 2,
        urgency: 4,
        category: 4,
        status: 2,
        members: [6, 1],
        client_name: "Client Japan",
        order: 4
      },
      {
        id: 5,
        title_ticket: "Tickets 5",
        received_date: new Date().toISOString(),
        ticket_id: 1994,
        priority: 3,
        urgency: 5,
        category: 5,
        status: 1,
        members: [3, 6],
        client_name: "Client US",
        assigneeByMe: true,
        order: 5
      }
    ]
  },
  2000: {
    results: [
      {
        id: 6,
        title_ticket: "Tickets 6",
        received_date: new Date().toISOString(),
        ticket_id: 1996,
        priority: 1,
        urgency: 1,
        category: 6,
        status: 1,
        members: [1, 3],
        client_name: "Client singapore",
        assigneeByMe: true,
        order: 6
      },
      {
        id: 7,
        title_ticket: "Tickets 7",
        received_date: new Date().toISOString(),
        ticket_id: 1992,
        priority: 5,
        urgency: 2,
        category: 7,
        status: 2,
        members: [5, 3],
        client_name: "Client India",
        order: 7
      },
      {
        id: 8,
        title_ticket: "Tickets 8",
        received_date: new Date().toISOString(),
        ticket_id: 1993,
        priority: 4,
        urgency: 3,
        category: 8,
        status: 3,
        members: [1, 3, 5],
        client_name: "Client Korea",
        assigneeByMe: true,
        order: 8
      },
      {
        id: 9,
        title_ticket: "Tickets 9",
        received_date: new Date().toISOString(),
        ticket_id: 1991,
        priority: 2,
        urgency: 4,
        category: 2,
        status: 2,
        members: [2, 3],
        client_name: "Client Japan",
        order: 9
      },

      {
        id: 10,
        title_ticket: "Tickets 10",
        received_date: new Date().toISOString(),
        ticket_id: 1994,
        priority: 3,
        urgency: 5,
        category: 3,
        status: 1,
        members: [1, 2],
        client_name: "Client US",
        assigneeByMe: true,
        order: 10
      },
      {
        id: 11,
        title_ticket: "Tickets 11",
        received_date: new Date().toISOString(),
        ticket_id: 1996,
        priority: 1,
        urgency: 1,
        category: 1,
        status: 1,
        members: [3, 4],
        client_name: "Client singapore",
        assigneeByMe: true,
        order: 11
      }
    ]
  },
  3000: {
    results: [
      {
        id: 12,
        title_ticket: "Tickets 12",
        received_date: new Date().toISOString(),
        ticket_id: 1992,
        priority: 5,
        urgency: 2,
        category: 3,
        status: 2,
        members: [5, 6],
        client_name: "Client India",
        order: 12
      },
      {
        id: 13,
        title_ticket: "Tickets 13",
        received_date: new Date().toISOString(),
        ticket_id: 1993,
        priority: 4,
        urgency: 3,
        category: 5,
        status: 3,
        members: [1, 4, 2],
        client_name: "Client Korea",
        assigneeByMe: true,
        order: 13
      },
      {
        id: 14,
        title_ticket: "Tickets 14",
        received_date: new Date().toISOString(),
        ticket_id: 1991,
        priority: 2,
        urgency: 4,
        category: 6,
        status: 2,
        members: [1],
        client_name: "Client Japan",
        order: 14
      },
      {
        id: 15,
        title_ticket: "Tickets 15",
        received_date: new Date().toISOString(),
        ticket_id: 1994,
        priority: 3,
        urgency: 5,
        category: 7,
        status: 1,
        members: [2],
        client_name: "Client US",
        assigneeByMe: true,
        order: 15
      },
      {
        id: 16,
        title_ticket: "Tickets 16",
        received_date: new Date().toISOString(),
        ticket_id: 1996,
        priority: 1,
        urgency: 1,
        category: 8,
        status: 1,
        members: [3],
        client_name: "Client singapore",
        assigneeByMe: true,
        order: 16
      },
      {
        id: 17,
        title_ticket: "Tickets 17",
        received_date: new Date().toISOString(),
        ticket_id: 1992,
        priority: 5,
        urgency: 2,
        category: 2,
        status: 2,
        members: [4],
        client_name: "Client India",
        order: 17
      },
      {
        id: 18,
        title_ticket: "Tickets 18",
        received_date: new Date().toISOString(),
        ticket_id: 1993,
        priority: 4,
        urgency: 3,
        category: 1,
        status: 3,
        members: [5],
        client_name: "Client Korea",
        assigneeByMe: true,
        order: 18
      }
    ]
  },
  4000: {
    results: [
      {
        id: 19,
        title_ticket: "Tickets 19",
        received_date: new Date().toISOString(),
        ticket_id: 1991,
        priority: 2,
        urgency: 4,
        category: 6,
        status: 2,
        members: [6],
        client_name: "Client Japan",
        order: 19
      },
      {
        id: 20,
        title_ticket: "Tickets 20",
        received_date: new Date().toISOString(),
        ticket_id: 1994,
        priority: 3,
        urgency: 5,
        category: 5,
        status: 1,
        members: [3, 1],
        client_name: "Client US",
        assigneeByMe: true,
        order: 20
      },
      {
        id: 21,
        title_ticket: "Tickets 21",
        received_date: new Date().toISOString(),
        ticket_id: 1996,
        priority: 1,
        urgency: 1,
        category: 1,
        status: 1,
        members: [2, 3],
        client_name: "Client singapore",
        assigneeByMe: true,
        order: 21
      },
      {
        id: 22,
        title_ticket: "Tickets 22",
        received_date: new Date().toISOString(),
        ticket_id: 1992,
        priority: 5,
        urgency: 2,
        category: 2,
        status: 2,
        members: [1, 4],
        client_name: "Client India",
        order: 22
      },
      {
        id: 23,
        title_ticket: "Tickets 23",
        received_date: new Date().toISOString(),
        ticket_id: 1993,
        priority: 4,
        urgency: 3,
        category: 1,
        status: 3,
        members: [1, 3, 2],
        client_name: "Client Korea",
        assigneeByMe: true,
        order: 23
      },
      {
        id: 24,
        title_ticket: "Tickets 24",
        received_date: new Date().toISOString(),
        ticket_id: 1991,
        priority: 2,
        urgency: 4,
        category: 3,
        status: 2,
        members: [3],
        client_name: "Client Japan",
        order: 24
      },
      {
        id: 25,
        title_ticket: "Tickets 25",
        received_date: new Date().toISOString(),
        ticket_id: 1994,
        priority: 3,
        urgency: 5,
        category: 7,
        status: 1,
        members: [4, 5],
        client_name: "Client US",
        assigneeByMe: true,
        order: 25
      }
    ]
  }
};
